// projects/humanresources-personnel/src/assets/i18n/*/hr-per-object-content.json
export class HrPerObjectContentKey {
    private static readonly keyPrefix = 'hrPerObjectContent';
    public static title = `${HrPerObjectContentKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerObjectContentKey.keyPrefix}.pageHeader`;
    public static object = `${HrPerObjectContentKey.keyPrefix}.object`;
    public static objectDefinition = `${HrPerObjectContentKey.keyPrefix}.objectDefinition`;
}
